// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_wrapper__KsDQJ {
  flex-direction: column;
  align-items: baseline;
  margin: 48px 0px;
  width: calc(100vw - 400px);
}
.Layout_headerContainer__OPtIG {
  margin-bottom: 48px;
}

.Layout_titleContainer__UwnxL {
  display: none;
}
.Layout_title__slvNO {
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
  text-align: left;
}
.Layout_searchIcon__VNFd8,
.Layout_mobileSearchIcon__ddx9J {
  height: 24px;
  margin: 10px 16px 0px;
  position: absolute;
  width: 24px;
}

.Layout_mobileSearchIcon__ddx9J {
  top: 16px;
  left: 4px;
  z-index: 100;
}
.Layout_mobileSearchInput__ibte8,
.Layout_searchInput__P89A1 {
  border: 1px solid #d9dce0;
  height: 46px;
  padding: 8px 16px 8px 46px;
  border-radius: 8px;
  box-shadow: 0px 0px 20px 0px rgba(186, 197, 210, 0.6);
}
.Layout_mobileSearchIcon__ddx9J,
.Layout_mobileSearchInput__ibte8 {
  transition: all ease 1s;
  animation: Layout_zoomIn__Gl\\+0S 500ms cubic-bezier(0.165, 0.84, 0.44, 1);
}
.Layout_mobileSearchInput__ibte8 {
  width: 97%;
  position: absolute;
  top: 16px;
  left: 10px;
}
.Layout_searchInput__P89A1 {
  border: 1px solid #d9dce0;
  width: 438px;
  border-radius: 8px;
}
.Layout_searchInput__P89A1::placeholder,
.Layout_mobileSearchInput__ibte8::placeholder {
  color: rgba(95, 109, 126, 0.6);
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.Layout_searchInput__P89A1:focus {
  border: 1px solid rgba(203, 156, 45, 1);
  outline: none;
}
.Layout_mobileHeader__TNf5D {
  display: none;
}

@media screen and (max-width: 1280px) {
  .Layout_titleContainer__UwnxL {
    display: block;
    margin-top: 100px;
  }
  .Layout_headerContainer__OPtIG {
    display: none;
  }
  .Layout_wrapper__KsDQJ {
    padding: 0 35px;
    max-width: 90%;
    margin: 80px 0px;
    width: 100%;
  }
  .Layout_mobileHeader__TNf5D {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    box-shadow: 0px 0px 10px 1px rgba(186, 197, 210, 0.6);
  }
}
@media screen and (max-width: 600px) {
  .Layout_wrapper__KsDQJ {
    padding: 0;
    padding-left: 23px;
  }
  .Layout_title__slvNO {
    font-size: 35px;
    line-height: 40px;
  }
  .Layout_searchInput__P89A1 {
    width: 100%;
  }
}

@media screen and (max-width: 376px) {
  .Layout_wrapper__KsDQJ {
    padding: 0;
    padding-left: 20px;
  }
  .Layout_title__slvNO {
    font-size: 30px;
    line-height: 34px;
  }
  .Layout_mobileSearchInput__ibte8 {
    width: 95%;
  }
}
@keyframes Layout_zoomIn__Gl\\+0S {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;EACT,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,qDAAqD;AACvD;AACA;;EAEE,uBAAuB;EACvB,yEAA0D;AAC5D;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,qDAAqD;EACvD;AACF;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".wrapper {\n  flex-direction: column;\n  align-items: baseline;\n  margin: 48px 0px;\n  width: calc(100vw - 400px);\n}\n.headerContainer {\n  margin-bottom: 48px;\n}\n\n.titleContainer {\n  display: none;\n}\n.title {\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n  text-align: left;\n}\n.searchIcon,\n.mobileSearchIcon {\n  height: 24px;\n  margin: 10px 16px 0px;\n  position: absolute;\n  width: 24px;\n}\n\n.mobileSearchIcon {\n  top: 16px;\n  left: 4px;\n  z-index: 100;\n}\n.mobileSearchInput,\n.searchInput {\n  border: 1px solid #d9dce0;\n  height: 46px;\n  padding: 8px 16px 8px 46px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 20px 0px rgba(186, 197, 210, 0.6);\n}\n.mobileSearchIcon,\n.mobileSearchInput {\n  transition: all ease 1s;\n  animation: zoomIn 500ms cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.mobileSearchInput {\n  width: 97%;\n  position: absolute;\n  top: 16px;\n  left: 10px;\n}\n.searchInput {\n  border: 1px solid #d9dce0;\n  width: 438px;\n  border-radius: 8px;\n}\n.searchInput::placeholder,\n.mobileSearchInput::placeholder {\n  color: rgba(95, 109, 126, 0.6);\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.searchInput:focus {\n  border: 1px solid rgba(203, 156, 45, 1);\n  outline: none;\n}\n.mobileHeader {\n  display: none;\n}\n\n@media screen and (max-width: 1280px) {\n  .titleContainer {\n    display: block;\n    margin-top: 100px;\n  }\n  .headerContainer {\n    display: none;\n  }\n  .wrapper {\n    padding: 0 35px;\n    max-width: 90%;\n    margin: 80px 0px;\n    width: 100%;\n  }\n  .mobileHeader {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    box-shadow: 0px 0px 10px 1px rgba(186, 197, 210, 0.6);\n  }\n}\n@media screen and (max-width: 600px) {\n  .wrapper {\n    padding: 0;\n    padding-left: 23px;\n  }\n  .title {\n    font-size: 35px;\n    line-height: 40px;\n  }\n  .searchInput {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 376px) {\n  .wrapper {\n    padding: 0;\n    padding-left: 20px;\n  }\n  .title {\n    font-size: 30px;\n    line-height: 34px;\n  }\n  .mobileSearchInput {\n    width: 95%;\n  }\n}\n@keyframes zoomIn {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Layout_wrapper__KsDQJ`,
	"headerContainer": `Layout_headerContainer__OPtIG`,
	"titleContainer": `Layout_titleContainer__UwnxL`,
	"title": `Layout_title__slvNO`,
	"searchIcon": `Layout_searchIcon__VNFd8`,
	"mobileSearchIcon": `Layout_mobileSearchIcon__ddx9J`,
	"mobileSearchInput": `Layout_mobileSearchInput__ibte8`,
	"searchInput": `Layout_searchInput__P89A1`,
	"zoomIn": `Layout_zoomIn__Gl+0S`,
	"mobileHeader": `Layout_mobileHeader__TNf5D`
};
export default ___CSS_LOADER_EXPORT___;
